import SecurityColumn from './SecurityColumn';

export default SecurityColumn;
